<template>
  <section>
    <card v-if="!initialLoading">
      <card-header :title="$t('active_sessions.current_session')">
      </card-header>
      <card-content>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>{{ $t('active_sessions.ip') }}</th>
              <th>{{ $t('active_sessions.current_session_logon_time') }}</th>
              <th>{{ $t('active_sessions.browser') }}</th>
              <th>{{ $t('active_sessions.platform') }}</th>
              <th>{{ $t('active_sessions.device') }}</th>
              <th>{{ $t('active_sessions.factors') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="session, idx in activeSessions" :key="idx" :class="{'is-selected': idx === 0}">
              <td>{{ session.ip_addr }}</td>
              <td>{{ session.created_at | date }}</td>
              <td>{{ session.browser || "" }}</td>
              <td>{{ session.platform }}</td>
              <td>{{ session.device_type }}</td>
              <td>{{ session.auth_codes }}</td>
            </tr>
          </tbody>
        </table>       
      </card-content>
    </card>
    <br>
    <card v-if="!initialLoading">
      <card-header :title="$t('devices.all_devices')">
      </card-header>
      <card-content>
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>{{ $t('devices.name') }}</th>
              <th>{{ $t('devices.device_type') }}</th>
              <th>{{ $t('devices.last_use_date') }}</th>
              <th>{{ $t('devices.status') }}</th>
              <th>{{ $t('devices.remembered') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="device in devices" :key="device.id">
              <td>{{ device.display }}</td>
              <td>{{ device.deviceType }}</td>
              <td>{{ device.lastUse | date }}</td>
              <td>
                <p :class="'tag ' + getIconClass(device)">{{ $t("devices.status_type." + device.status.toLowerCase()) }}</p>
              </td>
              <td style="text-align: center;">
                  <div style="display: inline-block;">
                  <checkbox v-model="device.isRemembered" @input="rememberedChanged(device)" :disabled="rememberedLoading"></checkbox>
                </div>
              </td>
              <td>
                <router-link v-if="device.status.toLowerCase() == 'active'" :to="{ name: 'deviceCompromised', params: { id: device.id } }">
                  {{  $t('devices.compromised') }}
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </card-content>
    </card>
    <div style="margin-top: 18%;" class="columns is-centered is-vcentered" v-if="initialLoading">
      <div class="loader">
    </div>
    </div>
  </section>
</template>
<script>
import deviceAPI from "@/services/devices";
import profile from "@/services/profile";
import { Card, CardContent, Checkbox } from "@/components";

export default {
  name: "SessionsList",
  components: {
    Card,
    CardContent,
    Checkbox
  },
  data() {
    return {
      activeSessions: [],
      devices: [],
      initialLoading: false,
      rememberedLoading: false,
    };
  },
  methods: {
    async fetch() {
      this.initialLoading = true
      let devicesTask = deviceAPI.personalDevices()
      let sessionTask = profile.sessions()

      try {
        // sessions
        let resp = await sessionTask
        this.activeSessions = resp.data
          .filter( i => !i.expired)
          .sort(function(a, b) { return new Date(b.created_at) - new Date(a.created_at); })
          .slice(0, 10)
        
        
        // devices
        this.devices = (await devicesTask).data
        this.devices.sort(function(a, b) { return new Date(b.lastUse) - new Date(a.lastUse); })
      } catch (err){
        console.log(err)
      }

      this.initialLoading = false
    },
    getIconClass(device) {
      return `status-icon status-${device.status.toLowerCase()}`
    },
    getIconName(device) {
      switch (device.status.toLowerCase()) {
        case 'active':
          return 'cellphone'
        case 'stopped':
          return 'cellphone-lock'
        case 'deactivated':
          return 'cellphone-off'
      }
      return 'cellphone'
    },
    rememberedChanged(device){
      this.rememberedLoading = true
      
      let handleError = (err)=>{
        this.refresh()
        console.log(err);
        this.rememberedLoading = false
      }

      if (device.isRemembered) {
        deviceAPI.remember(device.id).then(() => {
          this.rememberedLoading = false
        }, err => {
          handleError(err)
        })
      }
      else {
        deviceAPI.forget(device.id).then(() => {
          this.rememberedLoading = false
        }, err => {
          handleError(err)
        })
      }
    },
    refresh(){
      this.fetch()
    }
  },
  computed:{
    
  },
  filters: {
    date(value) {
      return new Date(value).toLocaleString();
    }
  },
  mounted() {
    this.fetch();
  }
};
</script>
<style>
.status-active {
  background-color: green !important;
  color: white !important;
}

.status-stopped {
  background-color: yellow !important;
  color: black !important;
}

.status-deactivated {
  background-color: red !important;
  color: white !important;
}

.status-icon {
  border-radius: 4px;
  display: flex;
  padding: 0 4px;
}

.loader {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  border: 20px solid;
  border-color: rgba(169,169,169, 1) rgba(211,211,211, 1) rgba(169,169,169, 1) rgba(211,211,211, 1);
  box-sizing: border-box;
  animation: rotation 1.6s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>